import { AGENT_VECTORIZE_SYNC_BATCH } from '../config/agentConfig';
import i18n from '../../i18n';
import { buildAgentFullCatalog } from './agentContextBuilder';
import {
  buildVectorizeRecordsFromCatalog,
  catalogFingerprint,
} from './agentVectorizeBuilder';
import { sendAgentVectorizeSyncRequest } from './agentCloudClient';

const SYNC_STORAGE_KEY = 'qawaem_agent_vectorize_fp';

let syncInFlight = null;

const vp = (key, opts) => i18n.t(`modules.shared.aiAgent.vectorizeSync.${key}`, opts);

export async function syncAgentVectorIndex({ companyId, licenseKey, force = false }) {
  if (!companyId || !licenseKey) {
    return { success: false, error: vp('license_missing') };
  }

  if (syncInFlight) {
    return syncInFlight;
  }

  syncInFlight = (async () => {
    try {
      const catalog = await buildAgentFullCatalog();
      const fingerprint = catalogFingerprint(catalog);
      const previous = localStorage.getItem(`${SYNC_STORAGE_KEY}:${companyId}`);

      if (!force && previous === fingerprint) {
        return {
          success: true,
          skipped: true,
          message: vp('index_up_to_date'),
          total: 0,
        };
      }

      const records = buildVectorizeRecordsFromCatalog(catalog);
      if (!records.length) {
        return { success: true, skipped: true, message: vp('nothing_to_index'), total: 0 };
      }

      let upserted = 0;
      let skipped = 0;

      for (let i = 0; i < records.length; i += AGENT_VECTORIZE_SYNC_BATCH) {
        const batch = records.slice(i, i + AGENT_VECTORIZE_SYNC_BATCH);
        const result = await sendAgentVectorizeSyncRequest({
          companyId,
          licenseKey,
          records: batch,
        });
        upserted += result.upserted || 0;
        skipped += result.skipped || 0;
      }

      try {
        localStorage.setItem(`${SYNC_STORAGE_KEY}:${companyId}`, fingerprint);
      } catch {
        /* ignore quota */
      }

      return {
        success: true,
        total: records.length,
        upserted,
        skipped,
        fingerprint,
      };
    } catch (error) {
      console.error('Vectorize sync failed:', error);
      return {
        success: false,
        error: error.message || vp('sync_failed'),
      };
    } finally {
      syncInFlight = null;
    }
  })();

  return syncInFlight;
}

export function clearAgentVectorizeFingerprint(companyId) {
  if (!companyId) return;
  try {
    localStorage.removeItem(`${SYNC_STORAGE_KEY}:${companyId}`);
  } catch {
    /* ignore */
  }
}
